import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../Services/Axios/axios";
import { BeatLoader } from "react-spinners";
import { organizationDetail } from "../Context/SelectedOrganization";

const CompanyDashboard = () => {
  const navigate = useNavigate();
  const [userDetail, setUserDetail] = useState({});
  const { setOrganizationData } = useContext(organizationDetail);
  const [companiesApproved, setCompaniesApproved] = useState([]);
  const [companiesPending, setCompaniesPending] = useState([]);
  const [companiesRejected, setCompaniesRejected] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleRegisterClick = () => {
    navigate("/register-your-business");
    // setBusinessStatus("pending");
  };
  const handleManageStoreClick = (company) => {
    setOrganizationData(company);
    sessionStorage.setItem("organization_id", company.id);
    navigate("/dashboard");
    // setBusinessStatus("pending");
  };

  const getOrganizationData = async () => {
    setLoading(true);
    try {
      const response = await axiosClient.get(
        `/company/${process.env.REACT_APP_API_VERSION}/user-organizations-list`
      );
      if (!response.data.error) {
        setCompaniesApproved(
          response.data.data.rows.filter((org) => org.status === 1)
        );
        setCompaniesPending(
          response.data.data.rows.filter((org) => org.status === 0)
        );
        setCompaniesRejected(
          response.data.data.rows.filter((org) => org.status === 2)
        );
        setLoading(false);
        // localStorage.setItem("userData", JSON.stringify(response.data.data));
      }
    } catch (error) {
      console.error("Error fetching organization data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    const data = JSON.parse(userData);
    setUserDetail(data);
    getOrganizationData();
  }, []);
  if (loading)
    return (
      <div className="loader">
        <BeatLoader color="#097C81" />
      </div>
    );
  return (
    <section style={{ backgroundColor: "#F7F7F7" }}>
      <div className="dashboard-container ">
        {/* Header */}
        <div className="dashboard-header">
          <h2>Companies</h2>
          <button className="app-register-btn" onClick={handleRegisterClick}>
            Register new business
          </button>
        </div>

        {/* Approved Companies */}
        <div className="company-section">
          {companiesApproved?.length > 0 ? (
            companiesApproved?.map((company) => (
              <div key={company.id} className="company-card">
                <div className="company-info">
                  <div className="company-icon">
                    {company.organization_name.charAt(0).toUpperCase()}
                  </div>
                  <p>{company.organization_name}</p>
                </div>
                <button
                  className="app-register-btn"
                  onClick={() => handleManageStoreClick(company)}
                >
                  Manage Store
                </button>
              </div>
            ))
          ) : (
            <p>No approved companies.</p>
          )}
        </div>

        {/* Pending Applications */}
        <div className="company-section">
          <h3>Pending Applications</h3>
          {companiesPending?.length > 0 ? (
            companiesPending?.map((company) => (
              <div key={company.id} className="company-card pending">
                <div className="company-info">
                  <div className="company-icon">
                    {company.organization_name.charAt(0).toUpperCase()}
                  </div>
                  <p>{company.organization_name}</p>
                </div>
                <button className="btn-disabled" disabled>
                  Invite Pending
                </button>
              </div>
            ))
          ) : (
            <p>No pending applications.</p>
          )}
        </div>

        {/* Rejected Applications */}
        <div className="company-section">
          <h3>Rejected Applications</h3>
          {companiesRejected?.length > 0 ? (
            companiesRejected?.map((company) => (
              <div key={company.id} className="company-card pending">
                <div className="company-info">
                  <div className="company-icon">
                    {company.organization_name.charAt(0).toUpperCase()}
                  </div>
                  <p>{company.organization_name}</p>
                </div>
                <button
                  className="app-register-btn"
                  onClick={() => {
                    navigate("/register-your-business", {
                      state: { data: company },
                    });
                  }}
                >
                  Re-Apply
                </button>
              </div>
            ))
          ) : (
            <p>No rejected applications.</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default CompanyDashboard;
